import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import SEO from '../components/SEO';

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      {/* Header */}
      <header className="px-6 md:px-12 lg:px-24 py-6 border-b border-gray-100">
        <nav className="flex items-center justify-between max-w-4xl mx-auto">
          <Link to="/" className="flex items-center gap-3">
            <img 
              src="/logo.png" 
              alt="mobbing-melden.de Logo" 
              className="h-14 w-auto"
            />
          </Link>
          <Link to="/" className="flex items-center gap-2 text-[#718096] hover:text-[#2D3748] transition-colors">
            <ChevronLeft className="w-4 h-4" />
            Zurück
          </Link>
        </nav>
      </header>

      {/* Content */}
      <main className="px-6 md:px-12 lg:px-24 py-12">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h1 className="text-3xl md:text-4xl font-bold text-[#2D3748] mb-8" style={{ fontFamily: 'Nunito' }}>
            Datenschutzerklärung
          </h1>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Allgemeine Hinweise</h3>
            <p className="text-[#718096] mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen 
              Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen 
              Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz 
              entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
            </p>
            
            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Datenerfassung auf dieser Website</h3>
            <p className="text-[#718096] mb-4">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten 
              können Sie dem Impressum dieser Website entnehmen.
            </p>
            <p className="text-[#718096] mb-4">
              <strong>Wie erfassen wir Ihre Daten?</strong><br />
              Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich 
              z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben (Meldung von Mobbing-Vorfällen).
            </p>
            <p className="text-[#718096] mb-4">
              Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind 
              vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs). 
              Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese Website betreten.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              2. Hosting
            </h2>
            <p className="text-[#718096] mb-4">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            </p>
            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Externes Hosting</h3>
            <p className="text-[#718096] mb-4">
              Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst 
              werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a. um IP-Adressen, 
              Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Webseitenzugriffe 
              und sonstige Daten, die über eine Website generiert werden, handeln.
            </p>
            <p className="text-[#718096] mb-4">
              Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und 
              bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und 
              effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter 
              (Art. 6 Abs. 1 lit. f DSGVO).
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              3. Allgemeine Hinweise und Pflichtinformationen
            </h2>
            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Datenschutz</h3>
            <p className="text-[#718096] mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln 
              Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften 
              sowie dieser Datenschutzerklärung.
            </p>
            <p className="text-[#718096] mb-4">
              Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. 
              Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. 
              Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. 
              Sie erläutert auch, wie und zu welchem Zweck das geschieht.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Hinweis zur verantwortlichen Stelle</h3>
            <p className="text-[#718096] mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              mobbing-melden.de c/o GAM<br />
              Pappelallee 64, 10437 Berlin, Deutschland<br />
              E-Mail: support@mobbing-melden.de<br />
              E-Mail: kontakt@mobbing-melden.de
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Speicherdauer</h3>
            <p className="text-[#718096] mb-4">
              Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, 
              verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. 
              Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung 
              widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für 
              die Speicherung Ihrer personenbezogenen Daten haben.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
            <p className="text-[#718096] mb-4">
              Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können 
              eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf 
              erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Recht auf Datenübertragbarkeit</h3>
            <p className="text-[#718096] mb-4">
              Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines 
              Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, 
              maschinenlesbaren Format aushändigen zu lassen.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Auskunft, Löschung und Berichtigung</h3>
            <p className="text-[#718096] mb-4">
              Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche 
              Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den 
              Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Recht auf Einschränkung der Verarbeitung</h3>
            <p className="text-[#718096] mb-4">
              Sie haben das Recht, die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              4. Datenerfassung auf dieser Website
            </h2>
            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Cookies</h3>
            <p className="text-[#718096] mb-4">
              Unsere Internetseiten verwenden so genannte "Cookies". Cookies sind kleine Textdateien und richten 
              auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung 
              (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.
            </p>
            <p className="text-[#718096] mb-4">
              <strong>Technisch notwendige Cookies:</strong> Wir setzen Cookies ein, um unsere Website 
              nutzerfreundlicher zu gestalten. Diese Cookies sind für den Betrieb der Website technisch notwendig. 
              Sie werden nach Ende Ihres Besuchs automatisch gelöscht.
            </p>
            <p className="text-[#718096] mb-4">
              Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und 
              Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell 
              ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Kontaktformular / Meldungen</h3>
            <p className="text-[#718096] mb-4">
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen oder Mobbing-Vorfälle melden, werden 
              Ihre Angaben aus dem Formular inklusive der von Ihnen dort angegebenen Kontaktdaten (sofern 
              freiwillig angegeben) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei 
              uns gespeichert.
            </p>
            <p className="text-[#718096] mb-4">
              Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre 
              Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher 
              Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten 
              Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) 
              oder auf Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
            </p>
            <p className="text-[#718096] mb-4">
              Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung 
              auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung 
              entfällt. Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
            </p>

            <h3 className="text-lg font-semibold text-[#2D3748] mb-3">Datei-Uploads</h3>
            <p className="text-[#718096] mb-4">
              Sie haben die Möglichkeit, im Rahmen einer Meldung Dateien (Bilder, Videos) hochzuladen. Diese 
              Dateien werden ausschließlich zur Dokumentation und Bearbeitung des gemeldeten Vorfalls verwendet. 
              Die Dateien werden auf unseren Servern gespeichert und nur autorisierten Mitarbeitern zugänglich 
              gemacht. Bei Weitergabe an Behörden werden Sie, sofern Kontaktdaten hinterlegt wurden, informiert.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              5. Besondere Hinweise für Minderjährige
            </h2>
            <p className="text-[#718096] mb-4">
              Diese Website richtet sich an Kinder und Jugendliche, die Mobbing oder ähnliche Vorfälle melden 
              möchten. Wir erheben nur die für die Bearbeitung notwendigen Daten. Die Angabe von Kontaktdaten 
              ist freiwillig. Minderjährige unter 16 Jahren sollten vor der Übermittlung personenbezogener Daten 
              (wie Name, E-Mail, Telefonnummer) die Einwilligung ihrer Eltern oder Erziehungsberechtigten einholen.
            </p>
            <p className="text-[#718096] mb-4">
              Wir empfehlen, dass Eltern oder Erziehungsberechtigte ihre Kinder bei der Nutzung dieser Website 
              begleiten und unterstützen.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-bold text-[#2D3748] mb-4" style={{ fontFamily: 'Nunito' }}>
              6. Weitergabe an Behörden
            </h2>
            <p className="text-[#718096] mb-4">
              Bei schwerwiegenden Fällen behalten wir uns vor, die gemeldeten Vorfälle samt Beweismaterial an 
              die zuständigen Behörden (z.B. Polizei, Jugendamt) weiterzugeben. Dies geschieht ausschließlich 
              zum Schutz der betroffenen Person und nur, wenn dies nach sorgfältiger Prüfung als notwendig 
              erachtet wird. Sofern Kontaktdaten hinterlegt wurden, werden Sie über eine solche Weitergabe 
              informiert.
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer className="px-6 md:px-12 lg:px-24 py-8 bg-white/50 border-t border-gray-100">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#A0AEC0]">
            © 2024 mobbing-melden.de
          </p>
          <div className="flex items-center gap-6">
            <Link to="/datenschutz" className="text-sm text-[#718096] hover:text-[#2D3748]">Datenschutz</Link>
            <Link to="/impressum" className="text-sm text-[#718096] hover:text-[#2D3748]">Impressum</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
